import {
	AfterViewInit,
	Component,
	ElementRef,
	input,
	output,
	signal,
	viewChild,
} from '@angular/core';

@Component({
	selector: 'ui-select-search',
	templateUrl: './select-search.component.html',
	standalone: false,
})
export class SelectSearchComponent implements AfterViewInit {
	placeholder = input<string>('');

	searchInput = viewChild<ElementRef<HTMLInputElement> | undefined>('searchInput');

	searchText = signal<string>('');

	searched = output<string>();
	focusNext = output<void>();

	clearSearch(): void {
		this.setSearch('');
	}

	onInput(event: Event): void {
		this.setSearch((event.target as HTMLInputElement).value);
	}

	private setSearch(value: string): void {
		this.searchText.set(value);
		this.searched.emit(value);
	}

	focus(): void {
		this.clearSearch();
		setTimeout(() => {
			this.searchInput()?.nativeElement.focus();
		}, 100);
	}

	onKeyDown(event: KeyboardEvent): void {
		if (event.key === 'Tab' && !event.shiftKey) {
			event.preventDefault();
			this.focusNext.emit();
		}
	}

	ngAfterViewInit(): void {
		queueMicrotask(() => {
			this.searchInput()?.nativeElement.focus();
		});
	}
}
